"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMithrilStateComponent = exports.IMithrilComponent = void 0;
const mobx_1 = require("mobx");
const mithril_1 = require("../mithril");
class IMithrilComponent {
    constructor(key) {
        this.lifeCycleParams = {};
        if (key != null) {
            this.lifeCycleParams.key = key;
        }
        this.lifeCycleParams.oncreate = this.onCreate.bind(this);
        this.lifeCycleParams.onupdate = this.onUpdate.bind(this);
        this.lifeCycleParams.onremove = this.onRemove.bind(this);
    }
    /**
     * (Mithril)Called after a DOM element is created and attached to the document.
     * @see https://mithril.js.org/lifecycle-methods.html#oncreate
     */
    onCreate(_vnode) { }
    /**
     * (Mithril) Called after a DOM element is updated, while attached to the document.
     * @see https://mithril.js.org/lifecycle-methods.html#onupdate
     */
    onUpdate(_vnode) { }
    /**
     * (Mithril) Called before a DOM element is removed from the document.
     * @see https://mithril.js.org/lifecycle-methods.html#onremove
     */
    onRemove(_vnode) { }
    view() {
        const nodes = this.nodes;
        if (Array.isArray(nodes)) {
            return mithril_1.m.fragment(this.lifeCycleParams, nodes);
        }
        return mithril_1.m.fragment(this.lifeCycleParams, [nodes]);
    }
}
exports.IMithrilComponent = IMithrilComponent;
class IMithrilStateComponent extends IMithrilComponent {
    constructor() {
        super();
        this.reactions = [];
    }
    autorun(view) {
        this.reactions.push((0, mobx_1.autorun)(view));
    }
    reaction(expression, effect, opts) {
        this.reactions.push((0, mobx_1.reaction)(expression, effect, opts));
    }
    onRemove() {
        this.reactions.forEach((r) => r());
    }
}
exports.IMithrilStateComponent = IMithrilStateComponent;
//# sourceMappingURL=mithril.component.js.map